import { render, staticRenderFns } from "./BidDetailDialog.vue?vue&type=template&id=61d5f4ec&"
import script from "./BidDetailDialog.vue?vue&type=script&lang=js&"
export * from "./BidDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports